import { render, staticRenderFns } from "./editBankGroup.vue?vue&type=template&id=2bfc55d2&scoped=true"
import script from "./editBankGroup.vue?vue&type=script&lang=js"
export * from "./editBankGroup.vue?vue&type=script&lang=js"
import style0 from "./editBankGroup.vue?vue&type=style&index=0&id=2bfc55d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc55d2",
  null
  
)

export default component.exports